// extracted by mini-css-extract-plugin
export default {"grid":"grid-area-module--grid--Eu8id","animate":"grid-area-module--animate--5PoQI","fadeOutIn":"grid-area-module--fadeOutIn--brAq7"};